import { blockMutators } from './block/mutators'
import { commitMutators } from './commit/mutators'
import { branchMutators } from './branch/mutators'
import { suggestedBranchMutators } from './suggested-branch/mutators'
import { repoInitMutators } from './repo-init/mutators'
import { sdkVersionMutators } from './sdk-version/mutators'
import { clientMutators } from './client/mutators'
import { userPreferencesMutators } from './user-preferences/mutators'
import { threadMutators } from './thread/mutators'
import { contentRequestMutators } from './content-request/mutators'
import { commentMutators } from './comment/mutators'
import { workflowRunMutators } from './block/mutators/workflow'
import { applySuggestion } from './apply-suggestion/mutators'

export type RepoSpaceMutators = typeof repoSpaceMutators

export const repoSpaceMutators = {
  ...blockMutators,
  ...commitMutators,
  ...repoInitMutators,
  ...branchMutators,
  ...workflowRunMutators,
  ...suggestedBranchMutators,
  ...sdkVersionMutators,
  ...userPreferencesMutators,
  ...clientMutators,
  ...threadMutators,
  ...contentRequestMutators,
  ...commentMutators,
  applySuggestion,
}
